module.exports = {"classes":["feedback-page","header-dark"],"title":"Feedback","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/feedback/metadata.json
// module id = 1614
// module chunks = 0